import { render, staticRenderFns } from "./TicketsMMCall.vue?vue&type=template&id=324589b0&scoped=true&"
import script from "./TicketsMMCall.vue?vue&type=script&lang=js&"
export * from "./TicketsMMCall.vue?vue&type=script&lang=js&"
import style0 from "./TicketsMMCall.vue?vue&type=style&index=0&id=324589b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324589b0",
  null
  
)

export default component.exports